module.exports = __webpack_public_path__ + "img/promotor.47a43b62.svg";